
import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";
import { useParams } from "react-router-dom";




const DeviceDeselectHistory = () => {
    const { id } = useParams();

    const [device, setDevice] = useState([]);
    const [deviceDeselectHistoryLogs, setDeviceDeselectHistoryLogs] = useState([]);

    const [query, setQuery] = useState("");
    useEffect(() => {
        axiosConfig.get("/device/deselect/history/"+ id).then((rsp) => {
            setDevice(rsp.data.device);
            setDeviceDeselectHistoryLogs(rsp.data.device_deselect_history);
            console.log(rsp.data);
        }, (err) => { });


    }, []);


    // const Search = (data) => {
    //     return data.filter(
    //         (item) =>
    //             item.box_id && item.box_id.toString().includes(query)
    //     );
    // };



    



    return (
        <div><Header title="Household Deselect History" />
            <MainMenu menu="device" />
            <div class="app-content content">
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row">
                    </div>
                    <div class="content-body">



                        <div class="row justify-content-md-center">
                            <div class="col-xl-12  col-12">
                                <section id="horizontal-vertical">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">

                                                <div class="card-content collapse show">
                                                    <div class="card-body card-dashboard">

                                                        <div class="row">
                                                            <div class="col-md-7"><div class="h3 font-weight-bold">{ device.device_name} - Household Selected-Deselected History</div></div>
                                                            {/* <div class="col-md-5"><input type="text" class="search form-control round border-primary mb-1" placeholder="Search by Device Name or Box ID" onChange={e => setQuery(e.target.value)} />
                                                            </div> */}
                                                        </div>

                                                        {/* <a class="btn btn-primary" href="/device/create">Create New</a> */}
                                                        {/* <button class="btn btn-success pull-right" onClick={exportDevices}>Export</button> */}
                                                        <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                            {
                                                                deviceDeselectHistoryLogs.length > 0 ? 
                                                                    <table class="table display nowrap table-striped table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Deselected At</th>
                                                                            <th>Deselected by</th>
                                                                            <th>Selected At</th>
                                                                            <th>Selected by</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {deviceDeselectHistoryLogs?.map((deviceHistory) =>
                                                                            <tr key={deviceHistory.id}>
                                                                                <td>{deviceHistory.start_date}</td>
                                                                                <td>{deviceHistory.deselected_by !== null ? <span class="">{deviceHistory.deselected_by_user.user_name}</span> : 'Not Available'}</td>
                                                                                <td>{deviceHistory.end_date !== null ? <span class="">{deviceHistory.end_date}</span> : <span class="text-warning">Stil Deselected</span>}</td>
                                                                                <td>{deviceHistory.selected_by !== null ? <span class="">{deviceHistory.selected_by_user.user_name}</span> : 'Not Available'}</td>

                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                                : <div class="h3 font-weight-bold text-center">No Log Found</div>
                                                            }
                                                            
                  
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section >





                            </div>
                        </div>


                        <br />



                        <br />


                    </div>
                </div>

            </div>
        </div>
    )

}
export default DeviceDeselectHistory;